import React from 'react';
import ReactDOM from 'react-dom';
import { getPortalContainer } from '../utils/domUtils';
import BlurredComponent from '../../MockPages/SEODashboard/BlurredComponent';
import {
  PaymentDialogOverlay,
  PaymentDialog as StyledPaymentDialog,
  PaymentDialogHeader,
  PaymentDialogTitle,
  CloseButtonModal,
  PaymentDialogContent,
  FormGroup,
  FormLabel,
  FormInput,
  FormTextArea,
  PaymentDialogFooter,
  CancelButton,
  SubmitButton
} from '../styled/Modals';

const PaymentDialog = ({
  showPaymentDialog,
  setShowPaymentDialog,
  paymentDescription,
  setPaymentDescription,
  paymentAmount,
  setPaymentAmount,
  paymentLink,
  setPaymentLink,
  handlePaymentSubmit,
  handleRapydPaymentSubmit
}) => {
  if (!showPaymentDialog) return null;

  const isRapydEnabled = process.env.REACT_APP_ENABLE_RAPYD === 'true';
  const paymentDialogContainer = getPortalContainer('payment-dialog-container');

  return ReactDOM.createPortal(
    <PaymentDialogOverlay>
      <StyledPaymentDialog>
        <PaymentDialogHeader>
          <PaymentDialogTitle>Request Payment</PaymentDialogTitle>
          <CloseButtonModal onClick={() => setShowPaymentDialog(false)}>✕</CloseButtonModal>
        </PaymentDialogHeader>
        <PaymentDialogContent>
          <FormGroup>
            <FormLabel htmlFor="payment-amount">Amount ($)</FormLabel>
            <FormInput
              id="payment-amount"
              type="number"
              min="0"
              step="0.01"
              placeholder="Enter amount"
              value={paymentAmount}
              onChange={(e) => setPaymentAmount(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel htmlFor="payment-description">Description</FormLabel>
            <FormTextArea
              id="payment-description"
              placeholder="Enter description of services"
              value={paymentDescription}
              onChange={(e) => setPaymentDescription(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel htmlFor="payment-link">Payment Link (Optional)</FormLabel>
            <FormInput
              id="payment-link"
              type="url"
              placeholder="https://payment-provider.com/link"
              value={paymentLink}
              onChange={(e) => setPaymentLink(e.target.value)}
            />
          </FormGroup>

          <div style={{
            backgroundColor: '#f0f7ff',
            border: '1px solid #2196f3',
            borderRadius: '8px',
            padding: '12px',
            margin: '16px 0',
            fontSize: '14px',
            color: '#1976d2',
            position: 'relative',
            minHeight: '60px'
          }}>
            {isRapydEnabled ? (
              <>
                <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>🔒 Rapyd Secure Payment</div>
                Choose "Send with Rapyd" to automatically generate a secure payment link, or use "Send Manual Request" to send with your custom payment link.
              </>
            ) : (
              <BlurredComponent>
                <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>🔒 Rapyd Secure Payment</div>
                Choose "Send with Rapyd" to automatically generate a secure payment link, or use "Send Manual Request" to send with your custom payment link.
              </BlurredComponent>
            )}
          </div>
        </PaymentDialogContent>
        <PaymentDialogFooter>
          <CancelButton onClick={() => setShowPaymentDialog(false)}>Cancel</CancelButton>
          {isRapydEnabled && (
            <SubmitButton
              onClick={handleRapydPaymentSubmit}
              style={{
                background: 'linear-gradient(135deg, #2196f3 0%, #1976d2 100%)',
                marginRight: '8px'
              }}
            >
              🔒 Send with Rapyd
            </SubmitButton>
          )}
          <SubmitButton onClick={handlePaymentSubmit}>
            {isRapydEnabled ? 'Send Manual Request' : 'Send Payment Request'}
          </SubmitButton>
        </PaymentDialogFooter>
      </StyledPaymentDialog>
    </PaymentDialogOverlay>,
    paymentDialogContainer
  );
};

export default PaymentDialog; 